// panel-wrapper.component.ts
import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { FieldWrapper } from "@ngx-formly/core";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-wrapper-text",
    template: `
    <div class="card question" [hidden]="to['shouldHide']">
      <div class="card-header bg-light p-md">
        <div class="row">
          <div class="col-md-11 text-left">
            @if (to['number'] && to['number'] != '') {
              <span
                class="question-number"
                [innerHtml]="to['number'] + ')'"
              ></span>
            }
            @if (to['title'] && to['title'] != '') {
              <span
                class="question-number"
                [innerHtml]="to['title']"
              ></span>
            }
          </div>
          <div class="col-md-1">
            <span>instructions</span>
          </div>
        </div>
      </div>
      <div class="card-body" [ngClass]="to['className']">
        <ng-container #fieldComponent></ng-container>
      </div>
      @if (to['isEdit']) {
        <div class="card-footer bg-light">
          <div class="mb-2 text-right">
            <button
              (click)="onDelete()"
              title="Delete"
              class="btn btn-outline-danger drop-shadow m-t-10"
              >
              <i class="fa fa-times"></i>
            </button>
            <button
              (click)="onEdit()"
              title="Edit"
              class="btn btn-outline-primary drop-shadow m-t-10"
              >
              <i class="fa fa-pencil-alt"></i>
            </button>
          </div>
        </div>
      }
    </div>
    `,
    styleUrls: ["./standard-wrapper.component.scss"],
    standalone: false
})
export class TextWrapperComponent extends FieldWrapper {
  @ViewChild("fieldComponent", { read: ViewContainerRef, static: true })
  // TS2612 fix.  Added declare.
  declare fieldComponent: ViewContainerRef;

  public onEdit() {
    this.field.templateOptions.onEdit(this.field["key"]);
  }

  public onDelete() {
    this.field.templateOptions.onDelete(this.field["key"]);
  }
}
